import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  initializeReactComponents() {
    // Pass the modal content as scope to search within it only
    const scope = this.contentTarget

    // Initialize carousel slider if present
    if (typeof window.initializeCarouselSlider === 'function') {
      window.initializeCarouselSlider(scope)
    }
    // Initialize before/after slider if present
    if (typeof window.initializeBeforeAfterSlider === 'function') {
      window.initializeBeforeAfterSlider(scope)
    }
  }

  preview(event) {
    event.preventDefault()

    const url = event.currentTarget.getAttribute('href')
    const modal = this.modalTarget
    const content = this.contentTarget

    content.innerHTML = `
      <div class="modal-body text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    `

    $(modal).modal('show')

    fetch(url, {
      method: 'GET',
    })
      .then(response => {
        return response.text()
      })
      .then(html => {
        content.innerHTML = html
        // Initialize React components for dynamically loaded content
        this.initializeReactComponents()
      })
      .catch(() => {
        content.innerHTML = `
          <div class="modal-body">
            <div class="alert alert-danger">
              Failed to load version preview.
            </div>
          </div>
        `
      })
  }
}
